import React from "react";

import { cn } from "@/lib/helpers/cn";
import { Link2 } from "@/ui2/atoms/Link";
import { getAutomationDataAttr } from "@/utils/automationUtils";

import Input from "../../components/UI/Input";
import { getVersionedConsentHref } from "@/lib/helpers/getVersionedConsentHref";

type Props = {
  consentEvent: VoidFunction;
  className?: string;
  version?: string;
};

export function ConsentToTreatment({ consentEvent, className, version }: Props) {
  const consentHref = getVersionedConsentHref({ policy: "treatment", version });

  return (
    <label
      className={cn(
        "tw:p-4 tw:!mb-0 tw:cursor-pointer tw:!inline-flex tw:items-baseline tw:gap-3 tw:bg-fill-senary tw:rounded-md",
        className,
      )}
      {...getAutomationDataAttr("consent-to-treatment-checkbox")}
    >
      <Input onClick={consentEvent} name="consent" type="checkbox" />

      <p className="tw:text-md tw:!mb-0 tw:text-text-tertiary">
        I acknowledge that I have read and agreed to aptihealth’s{" "}
        <Link2
          href={consentHref}
          isExternal
          {...getAutomationDataAttr("consent-to-treatment-link")}
        >
          Consent to Treatment
        </Link2>
      </p>
    </label>
  );
}
